// removed by extract-text-webpack-plugin
module.exports = {"main":"#1A2C5A","large_desktop":"only screen and (min-width: 1201px)","desktop":"only screen and (min-width: 1025px) and (max-width: 1200px)","tablet":"only screen and (min-width: 768px) and (max-width: 1024px)","mobile":"only screen and (max-width: 767px)","ourTeam":"ourTeam__1roS9","teamText":"teamText__3UExc","submit":"submit__3usZX","teamMember":"teamMember__3QzJD"};


//////////////////
// WEBPACK FOOTER
// ./components/OurTeam/style.css
// module id = qZdf
// module chunks = 0